// eslint-disable-next-line import/prefer-default-export
export function isSafari() {
  return (
    typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
}
